import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export interface IMediaQueryProps {
    xs: boolean;
    xl: boolean;
    sm: boolean;
    lg: boolean;
    md: boolean;
    smallScreen: boolean;
}
/*
xs, extra-small: 0px
sm, small: 600px
md, medium: 960px
lg, large: 1280px
xl, extra-large: 1920px
*/
export const WithMediaQuery = (Component) => {
    const WithMediaQueryComp = (props) => {
        const theme = useTheme();
        const xs = useMediaQuery(theme.breakpoints.up('xs'));
        const sm = useMediaQuery(theme.breakpoints.up('sm'));
        const md = useMediaQuery(theme.breakpoints.up('md'));
        const lg = useMediaQuery(theme.breakpoints.up('lg'));
        const xl = useMediaQuery(theme.breakpoints.up('xl'));
        const smallScreen = !lg && !xl && !md && !sm;
        return <Component xs={xs} xl={xl} sm={sm} ls={lg} md={md} smallScreen={smallScreen} {...props} />;
    }
    return WithMediaQueryComp;
};
